import request from '@/utils/request'

// 考试科目管理
export function getExamList(params) {
  return request({ url: '/exam/list', method: 'get', params })
}
export function addExam(data) {
  return request({ url: '/exam', method: 'post', data })
}
export function getExamDetail(id) {
  return request({ url: `/exam/${id}`, method: 'get' })
}
export function editExam(id, data) {
  return request({ url: `/exam/${id}`, method: 'post', data })
}
export function deleteExam(id) {
  return request({ url: `/exam/${id}`, method: 'delete' })
}
export function batchDeleteExam(ids) {
  return request({ url: '/exam/batch-delete', method: 'post', data: { ids } })
}
export function exportExam(params) {
  return request({ url: '/exam/export', method: 'get', params, responseType: 'blob' })
}

// 考场管理
export function getExamRoomList(params) {
  return request({ url: '/exam-room/list', method: 'get', params })
}
export function addExamRoom(data) {
  return request({ url: '/exam-room', method: 'post', data })
}
export function getExamRoomDetail(id) {
  return request({ url: `/exam-room/${id}`, method: 'get' })
}
export function editExamRoom(id, data) {
  return request({ url: `/exam-room/${id}`, method: 'post', data })
}
export function deleteExamRoom(id) {
  return request({ url: `/exam-room/${id}`, method: 'delete' })
}
export function batchDeleteExamRoom(ids) {
  return request({ url: '/exam-room/batch-delete', method: 'post', data: { ids } })
}
export function updateExamRoomStatus(id, data) {
  return request({ url: `/exam-room/${id}/status`, method: 'post', data })
}
export function exportExamRoom(params) {
  return request({ url: '/exam-room/export', method: 'get', params, responseType: 'blob' })
}
export function copyExamRoom(id) {
  return request({ url: `/exam-room/${id}/copy`, method: 'post' })
}

// 获取所有考场
export function getAllRoomList() {
  return request({
    url: '/exam-room/all',
    method: 'get'
  })
}

// 准考证管理
export function getAdmissionTicketList(params) {
  return request({ url: '/admission-ticket/list', method: 'get', params })
}
export function addAdmissionTicket(data) {
  return request({ url: '/admission-ticket', method: 'post', data })
}
export function getAdmissionTicketDetail(id) {
  return request({ url: `/admission-ticket/${id}`, method: 'get' })
}
export function editAdmissionTicket(id, data) {
  return request({ url: `/admission-ticket/${id}`, method: 'post', data })
}
export function deleteAdmissionTicket(id) {
  return request({ url: `/admission-ticket/${id}`, method: 'delete' })
}
export function batchDeleteAdmissionTicket(ids) {
  return request({ url: '/admission-ticket/batch-delete', method: 'post', data: { ids } })
}
export function updateAdmissionTicketStatus(id, data) {
  return request({ url: `/admission-ticket/${id}/status`, method: 'post', data })
}
export function exportAdmissionTicket(params) {
  return request({ url: '/admission-ticket/export', method: 'get', params, responseType: 'blob' })
}
export function generateAdmissionTicket(id) {
  return request({ url: `/admission-ticket/generate/${id}`, method: 'post' })
}
// 获取招聘场次列表
export function getSessionList() {
  return request({
    url: '/exam/session/list',
    method: 'get'
  })
}

// 获取职位列表
export function getPositionList(params) {
  return request({
    url: '/exam/position/list',
    method: 'get',
    params
  })
} 


// WEBPACK FOOTER //
// ./src/api/exam.js